module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Desktop 2x.c670b82e.png";